<div class="planner crm-scroll">
  <div class="planner-wrapper">
    <ng-container *ngTemplateOutlet="titleTemplate" />
    <ng-container *ngTemplateOutlet="plannerTemplate" />
    <ng-container *ngTemplateOutlet="actionsTemplate" />
    <ng-container *ngTemplateOutlet="loaderTemplate" />
  </div>
</div>

<ng-template #titleTemplate>
  <div class="planner-title-container">
    <span class="planner-title">
      {{ (mode === PlannerSidebarMode.Create ? 'planner.create' : 'planner.update') | translate }}
    </span>
    @if (baseService.isMobile) {
      <app-button (onChangeClick)="onCloseSidebar()" btnType="icon">
        <app-icon>close</app-icon>
      </app-button>
    }
  </div>
</ng-template>

<ng-template #plannerTemplate>
  <div class="planner-form">
    <ng-container *ngTemplateOutlet="plannerExistingTemplate" />

    <ng-container *ngTemplateOutlet="plannerMainTemplate" />

    <ng-container *ngTemplateOutlet="plannerPriceChangeTemplate" />

    <ng-container *ngTemplateOutlet="plannerCustomScheduleTemplate" />

    <ng-container *ngTemplateOutlet="plannerCheckboxesTemplate" />
  </div>
</ng-template>

<ng-template #plannerExistingTemplate>
  @if (existingPlanners.length) {
    <mat-card class="planner-form-card planner-form-card__scroll crm-scroll planner-existing-card">
      <div class="planner-form-card-title">{{ 'planner.card.existing' | translate }}:</div>

      <div class="planner-existing-list">
        @for (planner of existingPlanners; track planner.id) {
          <div class="planner-existing-list-item">
            @if (planner.payload.advert?.images?.[0]?.url) {
              <div class="planner-existing-list-thumb">
                <img [src]="$safeNavigationMigration(planner.payload.advert?.images?.[0]?.url)" alt="ad thumb" />
              </div>
            }

            <div class="planner-existing-list-content">
              <div class="planner-existing-list-header">
                <div class="planner-existing-list-title" [title]="planner.title">
                  {{ planner.title }}
                </div>

                <div class="planner-existing-list-badges">
                  <span class="planner-chip planner-chip__action">
                    {{ PLANNER_ACTIONS_REGISTRY[planner.action].name | translate }}
                  </span>

                  <span class="planner-chip planner-chip__status">
                    {{ 'olx.planners.' + planner.status.toLowerCase() | translate }}
                  </span>
                </div>
              </div>

              <ul class="planner-existing-meta">
                @if (planner.payload.advert_id) {
                  <li>
                    <span class="planner-existing-meta-label">
                      {{ 'planner.advert_id' | translate }}
                    </span>
                    <span class="planner-existing-meta-value">
                      {{ planner.payload.advert_id }}
                    </span>
                  </li>
                }
                @if (planner.payload.advert?.title) {
                  <li>
                    <span class="planner-existing-meta-label">
                      {{ 'planner.advert_name' | translate }}
                    </span>
                    <span class="planner-existing-meta-value">
                      {{ planner.payload.advert?.title }}
                    </span>
                  </li>
                }
                <li>
                  <span class="planner-existing-meta-label">
                    {{ 'planner.next_trigger_at' | translate }}
                  </span>
                  <span class="planner-existing-meta-value">
                    {{ planner.next_trigger_at | date: 'dd/MM/yyyy HH:mm:ss' }}
                  </span>
                </li>
                @if (planner.parent_name) {
                  <li>
                    <span class="planner-existing-meta-label">
                      {{ 'planner.planners_group' | translate }}
                    </span>
                    <span class="planner-existing-meta-value">
                      {{ planner.parent_name }}
                    </span>
                  </li>
                }
              </ul>
            </div>
          </div>
        }
      </div>
    </mat-card>
  }
</ng-template>

<ng-template #plannerMainTemplate>
  <mat-card class="planner-form-card">
    <span class="planner-form-card-title">{{ 'planner.card.main' | translate }}</span>
    <app-text-field
      type="v2"
      label="planner.title"
      placeholder="planner.title_placeholder"
      [formControl]="plannerForm.controls.title"
    />
    <app-dropdown-v2
      label="planner.action"
      placeholder="planner.action_placeholder"
      [items]="actions"
      [control]="plannerForm.controls.action"
    />
    <app-text-field
      type="date"
      label="planner.start_date"
      placeholder="planner.start_date_placeholder"
      [formControl]="plannerForm.controls.schedule.controls.start_date"
      [min]="todayDate()"
      [readonly]="true"
    />
    <app-text-field
      type="v2"
      inputType="time"
      label="planner.time"
      placeholder="planner.time_placeholder"
      [formControl]="plannerForm.controls.schedule.controls.time"
      [min]="getMinTime(plannerForm.controls.schedule.controls.start_date.value)"
    />
    <app-dropdown-v2
      label="planner.schedule_type"
      placeholder="planner.schedule_type_placeholder"
      [items]="scheduleTypes"
      [control]="plannerForm.controls.schedule.controls.type"
      (onValueChange)="onToggleCustomFields($event)"
    />
    @if (plannerForm.controls.schedule.controls.step) {
      <div class="planner-form-card-group">
        <app-text-field
          class="flex-fill"
          type="v2"
          inputType="number"
          [min]="1"
          label="planner.step_number"
          placeholder="planner.step_number_placeholder"
          [formControl]="plannerForm.controls.schedule.controls.step.controls.number"
        />
        <app-dropdown-v2
          class="flex-fill"
          label="planner.step_unit"
          placeholder="planner.step_unit_placeholder"
          [items]="timeUnits"
          [control]="plannerForm.controls.schedule.controls.step.controls.unit"
        />
      </div>
    }
  </mat-card>
</ng-template>

<ng-template #plannerPriceChangeTemplate>
  @if (plannerForm.controls.price_change && plannerForm.controls.action.value === PLANNER_OLX_ACTION.CHANGE_PRICE) {
    <mat-card class="planner-form-card">
      <span class="planner-form-card-title">{{ 'change_price' | translate }}</span>
      <div class="planner-section">
        <app-dropdown-v2
          label="bulk_change_price.mode"
          placeholder="bulk_change_price.mode"
          [items]="priceChangeModes"
          [control]="plannerForm.controls.price_change.controls.mode"
        />
        <app-text-field
          type="v2"
          inputType="number"
          [min]="0.01"
          label="bulk_change_price.value"
          placeholder="bulk_change_price.amount"
          [formControl]="plannerForm.controls.price_change.controls.value"
        />
      </div>
    </mat-card>
  }
</ng-template>

<ng-template #plannerCustomScheduleTemplate>
  @if (plannerForm.controls.schedule.controls.type.value === PLANNER_SCHEDULE_TYPE.CUSTOM) {
    <mat-card class="planner-form-card">
      <span class="planner-form-card-title">{{ 'planner.card.schedule' | translate }}</span>
      <div class="planner-section">
        <app-dropdown-v2
          label="planner.repeat_unit"
          placeholder="planner.repeat_unit_placeholder"
          [items]="timeUnits"
          [control]="plannerForm.controls.schedule.controls.repeat!.controls.unit"
        />
        <app-text-field
          type="v2"
          inputType="number"
          [min]="1"
          label="planner.repeat_every"
          placeholder="planner.repeat_every_placeholder"
          [formControl]="plannerForm.controls.schedule.controls.repeat!.controls.every"
        />
      </div>

      <div class="planner-section">
        <app-dropdown-v2
          label="planner.end_condition"
          placeholder="planner.end_condition_placeholder"
          [items]="endConditions"
          [control]="plannerForm.controls.schedule.controls.end_condition!.controls.type"
          (onValueChange)="onChangeEndCondition($event)"
        />
        @if (plannerForm.controls.schedule.controls.end_condition!.contains('max_occurrences')) {
          <app-text-field
            type="v2"
            inputType="number"
            [min]="1"
            label="planner.max_occurrences"
            placeholder="planner.max_occurrences_placeholder"
            [formControl]="plannerForm.controls.schedule.controls.end_condition!.controls.max_occurrences"
          />
        }
        <!--        TODO: make until_date validation-->
        @if (plannerForm.controls.schedule.controls.end_condition!.contains('until_date')) {
          <app-text-field
            type="date"
            label="planner.until_date"
            placeholder="planner.until_date_placeholder"
            [formControl]="plannerForm.controls.schedule.controls.end_condition!.controls.until_date"
            [min]="todayDate()"
            [readonly]="true"
          />
        }
      </div>

      <!--      TODO: week and month days picker-->
      <!--    <div class="planner-section">-->
      <!--      <label>{{ 'planner.week_days' | translate }}</label>-->
      <!--      &lt;!&ndash; Тут мають бути чекбокси чи toggle для днів тижня &ndash;&gt;-->
      <!--    </div>-->

      <!--    <div class="planner-section">-->
      <!--      <label>{{ 'planner.month_days' | translate }}</label>-->
      <!--      &lt;!&ndash; Тут мають бути чекбокси чи селектор чисел &ndash;&gt;-->
      <!--    </div>-->
    </mat-card>
  }
</ng-template>

<ng-template #plannerCheckboxesTemplate>
  <mat-card class="planner-form-card">
    <app-checkbox
      [disabled]="mode === PlannerSidebarMode.Update && payload.status !== PLANNER_STATUS.DRAFT"
      [(ngModel)]="isDraft"
      (ngModelChange)="onToggleStatus(PLANNER_STATUS.DRAFT)"
    >
      {{ 'planner.checkbox.draft' | translate }}
    </app-checkbox>
    @for (checkbox of selectedAction?.planner_config?.checkboxes; track $index) {
      <app-checkbox
        [(ngModel)]="plannerForm.controls.payloads.value![0]![checkbox.key]"
        (ngModelChange)="onToggleCheckbox($event, checkbox.key)"
      >
        {{ checkbox.label | translate }}
      </app-checkbox>
    }
    <app-checkbox
      [disabled]="PLANNER_SCOPE_TG_NOTIF_DISABLED.includes(payload.scope)"
      [(ngModel)]="plannerForm.controls.payloads.value![0].is_telegram"
      (ngModelChange)="onToggleCheckbox($event, 'is_telegram')"
    >
      {{ 'planner.checkbox.is_telegram' | translate }}
    </app-checkbox>
  </mat-card>
</ng-template>

<ng-template #actionsTemplate>
  <div class="planner-actions-container">
    <mat-card class="planner-actions">
      <app-button btnType="cancel" (onChangeClick)="onCloseSidebar()">
        {{ 'cancel' | translate }}
      </app-button>
      <app-button (onChangeClick)="onSave()">
        {{ (mode === PlannerSidebarMode.Create ? 'planner.create' : 'planner.update') | translate }}
      </app-button>
    </mat-card>
  </div>
</ng-template>

<ng-template #loaderTemplate>
  @if (loaders.planner_upsert) {
    <ngx-skeleton-loader class="skeleton-overlay" animation="pulse" [theme]="{ width: '100%', height: '100%' }" />
  }
</ng-template>
